import { ImageProps } from "../types";
import styled from "styled-components";

const StyledImage = styled.img<{ width?: string | number; height?: string | number }>`
  width: ${({ width }) => {
    if (typeof width === "number") return `${width}px`;
    if (typeof width === "string") return width;
    return "auto";
  }};
  height: ${({ height }) => {
    if (typeof height === "number") return `${height}px`;
    if (typeof height === "string") return height;
    return "auto";
  }};
  object-fit: contain;
  display: block;

  /* Apenas aplicar max-width se não especificarmos width/height */
  ${({ width, height }) => {
    if (!width && !height) {
      return `
        max-width: 100%;

        @media (max-width: 890px) {
          max-width: 70%;
          margin: 0 auto;
        }
      `;
    }
    return '';
  }}
`;

export const Image = ({ src, width, height }: ImageProps) => (
  <StyledImage
    src={`/img/${src}`}
    alt={src}
    width={width}
    height={height}
    draggable={false}
  />
);